import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import BlockSettings from './BlockSettings/BlockSettings';
import ElementSetting from './ElementSetting/ElementSetting';
import SbRightPanel from './StaffbaseSettings/SbRightPanel';

const RightPanel = ({ selectedElements, selectedBlocks, canvasBlocks, isWebApp }) => {
    const firstElement = selectedElements[0];
    const isText = firstElement ? firstElement.type === 'PARAGRAPH' : false;
    const selectedElementsExist = Object.keys(selectedElements.local).length > 0;

    let staffbaseBlock = null;
    if (selectedBlocks.length === 1) {
        const [selectedBlock] = canvasBlocks.filter((block) => block.index === selectedBlocks[0]);
        if (selectedBlock && selectedBlock.title === 'Staffbase News') {
            staffbaseBlock = selectedBlock;
        }
    }

    if (staffbaseBlock) {
        return <SbRightPanel staffbaseBlock={staffbaseBlock} isWebApp={isWebApp} isText={isText} />;
    }

    return (
        <div
            className="scrollFix"
            style={{
                width: 250,
                height: '100%',
                backgroundColor: 'white',
                position: 'relative',
                userSelect: 'none',
                overflowY: isText ? 'visible' : 'scroll',
            }}
        >
            {selectedElementsExist ? (
                <div style={{ width: 180, margin: '0 auto', height: 'calc(100% - 215px)', paddingTop: 12 }}>
                    <ElementSetting />
                </div>
            ) : (
                <div style={{ width: 180, margin: '0 auto', paddingTop: 12, height: 190 }}>
                    <div style={{ position: 'relative' }}>
                        <h2
                            style={{
                                display: 'inline-block',
                                fontSize: 12,
                                letterSpacing: 1,
                                fontWeight: 600,
                                color: '#535454',
                            }}
                        >
                            BLOCK SETTINGS
                        </h2>
                    </div>
                    <BlockSettings />
                </div>
            )}
        </div>
    );
};

const mapStateToProps = (state) => ({
    canvasBlocks: state.canvasBlocks.present,
    selectedElements: state.selectedElements,
    selectedBlocks: state.selectedBlocks,
    isWebApp: state.session.integration === 'APP',
});

RightPanel.propTypes = {
    selectedElements: PropTypes.object.isRequired,
    selectedBlocks: PropTypes.arrayOf(PropTypes.string).isRequired,
    canvasBlocks: PropTypes.arrayOf(PropTypes.object).isRequired,
    isWebApp: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(RightPanel);
